import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=5a104b8e&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=5a104b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a104b8e",
  null
  
)

export default component.exports